import UIImage from '@components/ui/UIImage'
import { Element } from 'html-react-parser'

interface ParticleImageProps {
	dom: Element
}

const ParticleImg = ({ dom }: ParticleImageProps) => {
	const styleList = dom.attribs?.style?.split(';').filter((item) => item.trim() !== '')
	const styleObject = styleList?.reduce((styles, style) => {
		const styleAttr = style.split(':').map((item) => item.trim())
		return {
			...styles,
			[styleAttr[0]]: styleAttr[1],
		}
	}, {})
	return <UIImage src={dom.attribs.src} alt={dom.attribs.alt} style={styleObject} />
}

export default ParticleImg
